// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\"> Account Access Features </h2> <p>Effortlessly manage your account through the home screen, track your loan details, handle payments and billing, update your account profile, and access essential tax information all in one place. </p> ";
// Exports
export default code;